import { LayoutFrame } from 'app-layout-frame';
import {
    DropdownList,
    DropdownListItem,
    IconFlag,
    IconMoneyBill,
    IconSignOut,
    IconSitemap,
    IconTachometer,
    Inline,
    Spinner
} from '@7shifts/sous-chef';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import Logo from 'sharedComponents/Logo';
import { useAuthContext } from '../contexts/AuthContext';
import { __ } from '../i18n';
import { User } from 'types';

const AdminPanelApp = () => {
    const { handleLogout, isAuth, loading, user } = useAuthContext();
    const navigate = useNavigate();
    const onLogout = () => {
        handleLogout().then(() => {
            navigate('/login?logged_out=1');
        });
    };

    if (loading) {
        return <Spinner block />;
    }

    if (!isAuth && !loading) {
        if (
            window.location.pathname &&
            window.location.pathname.indexOf('login') === -1
        ) {
            return (
                <Navigate
                    to={`/login?urlReturn=${window.location.pathname}${window.location.search}`}
                />
            );
        }
        if (
            window.location.search &&
            window.location.search.indexOf('logged_out') > 0
        ) {
            return <Navigate to={`/login?logged_out=1`} />;
        }
        return <Navigate to={`/login`} />;
    }

    if (!user) {
        throw new Error('User is not present! This should never happen!');
    }

    return <Layout user={user} onLogout={onLogout} />;
};

type LayoutProps = {
    user: User;
    onLogout: () => void;
};
const Layout = ({ onLogout }: LayoutProps) => {
    const navItems = [
        {
            label: __('main.dashboard'),
            isActive: true,
            isShowing: true,
            url: '/dashboard',
            icon: IconTachometer
        },
        {
            label: __('adminpanel.companies'),
            isActive: true,
            isShowing: true,
            url: '/companies',
            icon: IconSitemap
        },
        {
            label: 'Cobrança',
            isActive: true,
            isShowing: true,
            url: '/billing',
            icon: IconMoneyBill
        },
        {
            label: __('adminpanel.featureFlags'),
            isActive: true,
            isShowing: true,
            url: '/feature-flags',
            icon: IconFlag
        }
    ];
    return (
        <LayoutFrame
            navItems={navItems}
            appLogo={<Logo />}
            // @ts-expect-error Change the type to ReactNode instead of string
            companyName={
                <Inline>
                    Admin Panel
                </Inline>
            }
            userProfileImageURL=""
            accountMenuDropdown={
                <DropdownList>
                    <DropdownListItem
                        onClick={onLogout}
                        prefix={<IconSignOut />}
                    >
                        {__('main.logOut')}
                    </DropdownListItem>
                </DropdownList>
            }
            actions={[]}
        >
            <div className="padding-bottom-40">
                <Outlet />
            </div>
        </LayoutFrame>
    );
};

export default AdminPanelApp;
